"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.295 3.862H14.6c.772 0 1.4.628 1.4 1.4v7.99c0 .772-.628 1.4-1.4 1.4H1.4c-.772 0-1.4-.628-1.4-1.4v-7.99a1.4 1.4 0 0 1 .999-1.34v3.265H1v6.065a.4.4 0 0 0 .4.4h13.2a.4.4 0 0 0 .4-.4v-7.99c0-.22-.18-.4-.4-.4H2.005v-1h2.977l1.377-2.51h1.14l-1.377 2.51h4.032l-1.377-2.51h1.141l1.377 2.51ZM7.828 10.32H8.3l.072-2.623h-.62l.076 2.623Zm.525 1.02H7.78v-.553h.572v.553Zm.317-4.724 2.695 4.543a.731.731 0 0 1-.628 1.104h-5.39a.731.731 0 0 1-.63-1.104l2.697-4.543a.73.73 0 0 1 1.256 0Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M16.942 5.759H21.9c1.158 0 2.1.942 2.1 2.1v11.985c0 1.158-.942 2.1-2.1 2.1H2.1c-1.158 0-2.1-.942-2.1-2.1V7.859c0-.949.634-1.752 1.5-2.011v13.996c0 .33.27.6.6.6h19.8a.6.6 0 0 0 .6-.6V7.859a.6.6 0 0 0-.6-.6H3.008v-1.5h4.465l2.066-3.766h1.71L9.183 5.76h6.049l-2.066-3.766h1.711l2.065 3.766Zm-5.2 9.685h.708l.107-3.934h-.93l.115 3.934Zm.786 1.53h-.857v-.83h.857v.83Zm.477-7.085 4.042 6.814a1.095 1.095 0 0 1-.942 1.655H8.02a1.095 1.095 0 0 1-.942-1.655L11.12 9.89a1.096 1.096 0 0 1 1.885 0Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M22.59 7.679h6.61c1.544 0 2.8 1.256 2.8 2.8v15.98c0 1.544-1.256 2.8-2.8 2.8H2.8a2.803 2.803 0 0 1-2.8-2.8v-15.98c0-1.265.845-2.336 1.999-2.682v6.532H2v12.13c0 .44.359.8.8.8h26.4c.441 0 .8-.36.8-.8v-15.98c0-.441-.359-.8-.8-.8H4.01v-2h5.954l2.754-5.021h2.28l-2.754 5.02h8.065l-2.754-5.02h2.281l2.754 5.02Zm-6.934 12.913h.944l.143-5.245h-1.24l.153 5.245Zm1.049 2.04H15.56v-1.106h1.144v1.106Zm.635-9.447 5.39 9.086a1.46 1.46 0 0 1-1.256 2.206H10.693a1.46 1.46 0 0 1-1.256-2.206l5.39-9.086a1.461 1.461 0 0 1 2.513 0Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "m33.618 11.778-4.066-7.414h-2.19l3.762 6.86.468.854H17.26l.467-.854 3.763-6.86H19.3l-4.066 7.414-.164.3H6.159v1.92h38.117c.995 0 1.805.809 1.805 1.804v24.545c0 .995-.81 1.805-1.806 1.805H3.726c-.995 0-1.805-.81-1.805-1.805V12.548A3.751 3.751 0 0 0 0 15.803v24.545a3.73 3.73 0 0 0 3.725 3.725h40.55A3.728 3.728 0 0 0 48 40.347V15.802a3.728 3.728 0 0 0-3.724-3.724H33.782l-.165-.3ZM23.472 31.336h1.45l.22-8.057h-1.904l.235 8.057Zm1.611 3.133h-1.757V32.77h1.758v1.7Zm.976-14.51 8.28 13.955c.888 1.496-.191 3.39-1.93 3.39h-16.56c-1.739 0-2.817-1.894-1.93-3.39l8.28-13.956c.87-1.465 2.99-1.465 3.86 0Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M44.824 15.704 39.403 5.82h-2.92l5.016 9.146.624 1.138h-19.11l.623-1.138 5.017-9.146h-2.92l-5.421 9.885-.219.4H8.213v2.56h50.821a2.41 2.41 0 0 1 2.407 2.405v32.727a2.41 2.41 0 0 1-2.407 2.406H4.967a2.41 2.41 0 0 1-2.407-2.406V29.722l-.001-.768V16.731A5.002 5.002 0 0 0 0 21.07v32.727a4.972 4.972 0 0 0 4.967 4.966h54.067A4.971 4.971 0 0 0 64 53.796V21.07a4.971 4.971 0 0 0-4.966-4.966H45.043l-.219-.399ZM31.297 41.781h1.933l.293-10.742h-2.538l.312 10.742Zm2.148 4.178h-2.343v-2.265h2.343v2.265Zm1.3-19.348 11.04 18.608c1.184 1.995-.254 4.519-2.573 4.519h-22.08c-2.318 0-3.756-2.524-2.572-4.52l11.039-18.607c1.159-1.954 3.987-1.954 5.147 0Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconRearviewCamera = function IconRearviewCamera(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Rearview Camera' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "RearviewCamera"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconRearviewCamera.sizes = [16, 24, 32, 48, 64];
IconRearviewCamera.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconRearviewCamera;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/auto/RearviewCamera.js
// module id = 1943
// module chunks = 0